(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4982],{

/***/ 23276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/apple",
      function () {
        return __webpack_require__(15650);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InputCheckbox = function(props) {
    var input = props.input, _meta = props.meta, touched = _meta.touched, error = _meta.error, visited = _meta.visited;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "flex ".concat(props.className ? props.className : "", " ").concat(props.disabled ? "disabled" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, input, {
                        type: "checkbox",
                        required: props.required,
                        disabled: props.disabled,
                        className: "checkbox-input opacity-0 w-0 h-0 ".concat(touched && error ? "error" : "")
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "checkbox-control flex-none w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white ".concat(props.required ? "is-required" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            className: "",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true",
                            focusable: "false",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "3",
                                d: "M1.73 12.91l6.37 6.37L22.79 4.59"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "block Form-label label ".concat(props.spanClassName, " ").concat(props.required ? "is-required" : ""),
                        children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: props.label
                            }
                        }) : props.label
                    })
                ]
            }),
            props.required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: visited && error ? "" : "hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-red-brand text-sm",
                    children: error
                })
            })
        ]
    }));
};
InputCheckbox.defaultProps = {
    required: undefined,
    disabled: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (InputCheckbox);


/***/ }),

/***/ 64725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var FullWidthContainer = function(param) {
    var children = param.children;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative w-screen right-[50%] left-[50%] -mx-[50vw]",
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullWidthContainer);


/***/ }),

/***/ 10177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteStatics = _publicRuntimeConfig.settings.websiteStatics;
// TODO replace with site wide fallback
var DEFAULT_FALLBACK = "".concat(websiteStatics, "/images/benefits-placeholder.svg");
// onError is not fired sometimes because of next.js, so this may fail sometimes
var ImageWithFallback = function(props) {
    var fallback = props.fallback || DEFAULT_FALLBACK;
    var src = props.src || fallback;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", _objectSpread({}, props, {
        src: src,
        onError: function(e) {
            return e.target.src = fallback;
        }
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageWithFallback);


/***/ }),

/***/ 92772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Apple_AppleNavbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./components/Icons/AppleMenuIcon.js

var AppleMenuIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "69" : _width, _height = param.height, height = _height === void 0 ? "24" : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 69 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#010101",
            d: "M13.23 3.83A5.26 5.26 0 0 0 14.48 0c-1.21.05-2.66.8-3.53 1.82a5.04 5.04 0 0 0-1.26 3.7c1.33.11 2.7-.68 3.53-1.7m6.22 13.78c-.02.09-.5 1.73-1.65 3.42-1 1.46-2.02 2.92-3.66 2.94-1.6.04-2.11-.95-3.94-.95-1.82 0-2.4.93-3.91.99-1.57.06-2.77-1.58-3.77-3.04C.46 17.97-1.1 12.54.99 8.86a5.8 5.8 0 0 1 4.95-3c1.55-.02 2.99 1.05 3.94 1.05.94 0 2.7-1.29 4.56-1.1.78.04 2.96.31 4.37 2.38a5.3 5.3 0 0 0 .63 9.41m12.6-7.2-.5-1.56-.3-1.13h-.02l-.28 1.13-.5 1.56h1.6Zm1.74 2.49h-1l-.56-1.75h-1.93l-.53 1.75h-.98l1.9-5.96h1.18l1.92 5.96Zm4.09 0h-.84l-.05-.66c-.3.5-.76.75-1.36.75-.42 0-.75-.13-1-.4-.3-.31-.45-.8-.45-1.45V8.6h.95v2.36c0 .82.28 1.24.85 1.24.42 0 .72-.2.88-.62a1 1 0 0 0 .06-.36V8.61h.95v3.05l.03 1.24m3.31-3.6h-1.05v2.1c0 .53.18.8.56.8.16 0 .3-.02.41-.05l.03.72a2 2 0 0 1-.74.11c-.37 0-.66-.12-.87-.34-.21-.23-.32-.62-.32-1.16V9.32h-.63V8.6h.63v-.79l.93-.28V8.6h1.04v.7Zm4.58 3.59h-.94v-2.44c0-.77-.29-1.15-.87-1.15-.43 0-.74.22-.9.66-.03.1-.05.22-.05.35v2.58h-.95V6.62h.95V9.2h.02c.3-.46.72-.69 1.29-.69.39 0 .72.13.98.4.32.31.48.8.48 1.43v2.56-.01Zm4-2.16c0-.39-.08-.72-.26-1a.93.93 0 0 0-.85-.52.94.94 0 0 0-.86.51 2 2 0 0 0-.26 1.04c0 .4.08.72.26 1 .2.35.5.52.86.52.37 0 .65-.18.85-.52.18-.29.26-.63.26-1.03Zm.98-.03c0 .65-.19 1.2-.57 1.63-.39.44-.9.65-1.56.65a1.9 1.9 0 0 1-1.5-.63 2.3 2.3 0 0 1-.55-1.58c0-.64.18-1.21.58-1.63.37-.43.9-.64 1.54-.64.66 0 1.14.21 1.52.63.37.4.54.93.54 1.57Zm3.07-1.27-.3-.03c-.33 0-.6.13-.78.38-.17.23-.24.5-.24.85v2.24h-.94V9.93c0-.5 0-.94-.03-1.36h.83l.04.82h.02c.1-.28.26-.51.47-.68.22-.15.44-.22.69-.22.08 0 .16 0 .24.02v.92Zm1.75 3.46h-.95v-4.3h.95v4.3Zm.1-5.6c0 .18-.06.32-.16.42a.59.59 0 0 1-.43.16.52.52 0 0 1-.4-.17.58.58 0 0 1-.17-.41c0-.17.06-.3.17-.4.1-.11.25-.16.41-.16.17 0 .3.05.42.15.1.11.16.24.16.4m4.24 5.61h-3.48v-.56l1.7-2.26c.1-.14.3-.38.58-.7H56.6v-.78h3.27v.6L58.2 11.4c-.19.24-.38.48-.58.7h2.3v.78Zm3.4-2.61c0-.28-.06-.52-.19-.73-.16-.27-.41-.4-.75-.4a.9.9 0 0 0-.76.4c-.15.2-.25.45-.28.73h1.98Zm.91.25c0 .17 0 .31-.03.43h-2.86c0 .43.15.75.41.97.24.2.56.3.93.3.43 0 .8-.07 1.15-.2l.16.67c-.4.17-.9.26-1.44.26-.66 0-1.18-.2-1.56-.6a2.15 2.15 0 0 1-.56-1.58c0-.66.17-1.19.53-1.61a1.8 1.8 0 0 1 1.49-.7c.62 0 1.07.23 1.4.7.24.36.37.8.37 1.35m3.8.56v-.71c0-.12 0-.23-.03-.3a1.02 1.02 0 0 0-.98-.81.95.95 0 0 0-.82.43c-.2.28-.31.64-.31 1.08 0 .44.1.76.3 1.03.2.29.48.42.82.42.3 0 .56-.12.75-.34.17-.22.27-.48.27-.79m.98 1.8h-.84l-.05-.7h-.02c-.27.53-.72.8-1.37.8-.52 0-.95-.21-1.28-.62-.34-.4-.5-.92-.5-1.58 0-.69.18-1.26.55-1.68.35-.4.8-.6 1.32-.6.58 0 .98.2 1.22.58V6.63h.95v5.1c0 .42 0 .81.04 1.16m-36.98 5.89c0-.68-.4-1.02-1.22-1.03-.3 0-.53.02-.68.06v2h.66c.38 0 .67-.09.9-.28a.94.94 0 0 0 .33-.76m1.17 4.27h-.98c-.1-.18-.23-.64-.4-1.42a1.7 1.7 0 0 0-.36-.84c-.17-.17-.41-.24-.72-.24h-.6v2.5h-.94v-5.88c.44-.08.95-.11 1.54-.11.8 0 1.4.15 1.76.47.33.29.5.68.5 1.18 0 .37-.1.69-.32.96-.2.25-.45.43-.76.54.4.16.69.57.84 1.2l.25 1.02c.08.3.15.52.2.62m3.34-2.59c0-.29-.06-.53-.2-.74a.81.81 0 0 0-.75-.4.9.9 0 0 0-.76.4c-.15.2-.25.45-.28.74h1.99Zm.9.25c0 .16 0 .32-.03.42h-2.85c.01.43.15.75.41.98.24.2.56.3.94.3.43 0 .8-.08 1.16-.2l.15.66c-.4.18-.88.26-1.43.26-.66 0-1.18-.19-1.56-.6-.38-.39-.57-.9-.57-1.57s.18-1.2.53-1.62a1.8 1.8 0 0 1 1.5-.7c.62 0 1.08.23 1.39.7.25.37.38.8.38 1.35m3.43 1.12c0 .4-.14.73-.44.96-.3.24-.7.36-1.2.36-.49 0-.9-.1-1.25-.29l.2-.7a2 2 0 0 0 1.06.3c.48 0 .73-.18.73-.53a.53.53 0 0 0-.15-.4c-.11-.1-.3-.2-.57-.3-.76-.3-1.15-.7-1.15-1.24 0-.37.14-.68.43-.93a1.6 1.6 0 0 1 1.1-.37c.43 0 .79.09 1.08.25l-.2.68a1.66 1.66 0 0 0-.87-.25c-.2 0-.36.05-.46.14-.1.1-.17.22-.17.36 0 .14.06.27.18.36.1.08.3.19.58.28.73.29 1.11.71 1.11 1.3m3.51-1.33c0-.29-.06-.53-.19-.74a.82.82 0 0 0-.75-.4.9.9 0 0 0-.76.4c-.15.2-.25.45-.28.74h1.98Zm.91.25c0 .16 0 .32-.03.42h-2.86c0 .43.15.75.41.98.24.2.56.3.93.3.43 0 .8-.08 1.16-.2l.16.66c-.4.18-.89.26-1.43.26-.67 0-1.19-.19-1.57-.6-.37-.39-.56-.9-.56-1.57s.17-1.2.53-1.62a1.8 1.8 0 0 1 1.49-.7c.63 0 1.09.23 1.4.7.24.37.37.8.37 1.35m1.79-3.9h-.95v6.27h.95v-6.27Zm2.07 0h-.95v6.27h.95v-6.27Zm3.69 3.67c0-.29-.06-.53-.19-.74a.84.84 0 0 0-.76-.4.9.9 0 0 0-.75.4c-.16.2-.25.45-.29.74h1.99Zm.91.25c0 .16 0 .32-.04.42H50.9c0 .43.16.75.42.98.23.2.54.3.93.3.43 0 .8-.08 1.16-.2l.16.66c-.4.18-.9.26-1.44.26-.66 0-1.18-.19-1.56-.6-.38-.39-.56-.9-.56-1.57s.17-1.2.53-1.62a1.8 1.8 0 0 1 1.49-.7c.62 0 1.07.23 1.4.7.24.37.37.8.37 1.35m3.09-1.09-.3-.02a.93.93 0 0 0-.78.38c-.15.22-.23.5-.23.84v2.25h-.95v-2.95c0-.5 0-.94-.02-1.36h.82l.04.82h.02c.11-.28.26-.5.48-.67.2-.16.43-.23.68-.23l.24.01v.93Z"
        })
    });
};
/* harmony default export */ var Icons_AppleMenuIcon = (AppleMenuIcon);

// EXTERNAL MODULE: ./components/ImageWithFallback.js
var ImageWithFallback = __webpack_require__(10177);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
;// CONCATENATED MODULE: ./components/ShopInShop/Apple/AppleNavbar.js






var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteStatics = _publicRuntimeConfig.settings.websiteStatics;
var AppleNavbar = function(param) {
    var menu = param.menu;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/shop/apple",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "md:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_AppleMenuIcon, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/shop/apple",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "hidden md:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_AppleMenuIcon, {
                        width: "100",
                        height: "auto"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("menu", {
                className: "flex text-[12px] gap-[24px] md:gap-[40px] overflow-auto scrollbar-none",
                children: menu.map(function(menuItem, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                        className: "min-w-fit p-[12px] hover:opacity-80",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: menuItem.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                title: menuItem.name,
                                className: "flex flex-col gap-[8px] items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "rounded-full bg-white p-[12px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithFallback/* default */.Z, {
                                            src: menuItem.image ? (0,helpers/* resizeImage */.tg)(menuItem.image, "75x75") : null,
                                            alt: menuItem.name,
                                            fallback: "".concat(websiteStatics, "/images/applePlaceholder.svg"),
                                            className: "w-[48px] h-[48px] aspect-square object-contain"
                                        })
                                    }),
                                    menuItem.name
                                ]
                            })
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var Apple_AppleNavbar = (AppleNavbar);


/***/ }),

/***/ 6250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);



var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), settings = ref.publicRuntimeConfig.settings;
var ResponsiveShopBanner = function(param) {
    var banner = param.banner;
    var ref3, ref1, ref2;
    var desktopImage = (ref3 = banner.images) === null || ref3 === void 0 ? void 0 : ref3.desktop;
    var tabletImage = (ref1 = banner.images) === null || ref1 === void 0 ? void 0 : ref1.tablet;
    var mobileImage = (ref2 = banner.images) === null || ref2 === void 0 ? void 0 : ref2.mobile;
    var link = banner.url;
    var hasImage = desktopImage || tabletImage || mobileImage;
    if (!hasImage) {
        return null;
    }
    if (link) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
            href: link,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                title: "",
                children: [
                    mobileImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat(settings.cdn).concat(mobileImage),
                        className: "w-full sm:hidden",
                        alt: ""
                    }),
                    tabletImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat(settings.cdn).concat(tabletImage),
                        className: "w-full hidden sm:block lg:hidden",
                        alt: ""
                    }),
                    desktopImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat(settings.cdn).concat(desktopImage),
                        className: "w-full hidden lg:block",
                        alt: ""
                    })
                ]
            })
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            mobileImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "".concat(settings.cdn).concat(mobileImage),
                className: "w-full sm:hidden",
                alt: ""
            }),
            tabletImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "".concat(settings.cdn).concat(tabletImage),
                className: "w-full hidden sm:block lg:hidden",
                alt: ""
            }),
            desktopImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "".concat(settings.cdn).concat(desktopImage),
                className: "w-full hidden lg:block",
                alt: ""
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveShopBanner);


/***/ }),

/***/ 85241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);


var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_1__["default"])(), settings = ref.publicRuntimeConfig.settings;
var VideoBanner = function(param) {
    var banner = param.banner;
    var videoType = banner.video.url.split(".").pop();
    if (![
        "mp4",
        "webm",
        "ogg"
    ].includes(videoType)) {
        return null; // Unsupported video format
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
        name: "media",
        controls: true,
        autoPlay: true,
        muted: true,
        loop: true,
        className: "w-full h-auto object-fill m-auto aspect-video",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
            src: "".concat(settings.cdn).concat(banner.video.url),
            type: "video/".concat(videoType)
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (VideoBanner);


/***/ }),

/***/ 15650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ apple; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./components/FullWidthContainer.js
var FullWidthContainer = __webpack_require__(64725);
// EXTERNAL MODULE: ./components/ShopInShop/ResponsiveShopBanner.js
var ResponsiveShopBanner = __webpack_require__(6250);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./lib/api/helpers.js
var helpers = __webpack_require__(45963);
// EXTERNAL MODULE: ./components/ShopInShop/Apple/AppleNavbar.js + 1 modules
var AppleNavbar = __webpack_require__(92772);
// EXTERNAL MODULE: ./components/ExpandableProductList.js + 1 modules
var ExpandableProductList = __webpack_require__(4761);
// EXTERNAL MODULE: ./store/tracker/actions.js + 1 modules
var actions = __webpack_require__(48712);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
// EXTERNAL MODULE: ./components/ShopInShop/VideoBanner.js
var VideoBanner = __webpack_require__(85241);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./components/ImageWithFallback.js
var ImageWithFallback = __webpack_require__(10177);
// EXTERNAL MODULE: ./lib/helpers.js
var lib_helpers = __webpack_require__(15722);
// EXTERNAL MODULE: ./components/Price/index.js + 1 modules
var Price = __webpack_require__(40641);
// EXTERNAL MODULE: ./components/Status.js
var Status = __webpack_require__(66552);
// EXTERNAL MODULE: ./containers/Catalog/Actions/AddToCart.js + 6 modules
var AddToCart = __webpack_require__(38973);
// EXTERNAL MODULE: ./components/Ratings/index.js + 1 modules
var Ratings = __webpack_require__(57983);
// EXTERNAL MODULE: ./components/ProductCardLabel.js
var ProductCardLabel = __webpack_require__(34532);
// EXTERNAL MODULE: ./components/ProductList/ProductListImage.js
var ProductListImage = __webpack_require__(38403);
// EXTERNAL MODULE: ./components/ProductList/ProductListTitle.js
var ProductListTitle = __webpack_require__(95732);
// EXTERNAL MODULE: ./containers/Catalog/Actions/AddToCompare.js
var AddToCompare = __webpack_require__(23915);
// EXTERNAL MODULE: ./containers/Catalog/Actions/AddToWishlist.js + 1 modules
var AddToWishlist = __webpack_require__(9614);
// EXTERNAL MODULE: ./components/ProductList/ProductListVariations.js + 1 modules
var ProductListVariations = __webpack_require__(74196);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./components/ProductFinancing/index.js + 7 modules
var ProductFinancing = __webpack_require__(73363);
;// CONCATENATED MODULE: ./components/ShopInShop/Apple/AppleFeaturedCategoryProductCard.js
















var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, settings = _publicRuntimeConfig.settings, credex = _publicRuntimeConfig.credex, oney = _publicRuntimeConfig.oney;
var AppleFeaturedCategoryProductCard = function(param1) {
    var product = param1.product;
    var url_key = product.url_key, sku = product.sku, thumbnail = product.thumbnail, name = product.name, regular_price = product.regular_price, lowest_price = product.lowest_price, msrp_price = product.msrp_price, price = product.price, discount_type = product.discount_type, reviews_value = product.reviews_value, reviews_count = product.reviews_count, variations_info = product.variations_info;
    var ref1 = (0,lib_helpers/* productHelper */.gU)(product), isDisabled = ref1.isDisabled, isSaleable = ref1.isSaleable, isWestaco = ref1.isWestaco, hasStorePickup = ref1.hasStorePickup, isInSpecialCampaign = ref1.isInSpecialCampaign, hasPricePerFactor = ref1.hasPricePerFactor, hasPriceUnit = ref1.hasPriceUnit, isVirtualService = ref1.isVirtualService, isLocalSeller = ref1.isLocalSeller, getLabels = ref1.getLabels;
    var hasVariationsInfo = (variations_info === null || variations_info === void 0 ? void 0 : variations_info.size) > 1;
    var hasFinancingOptions = Boolean(isLocalSeller && product.installments_price > 0 && (credex.isEnabled && !isVirtualService || oney.isEnabled));
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "Product flex flex-col relative hover:shadow-mixRedYellow",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/".concat(url_key, "/cpd/").concat(sku, "/"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    title: "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListImage/* default */.Z, {
                        thumbnail: thumbnail,
                        name: name
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/".concat(url_key, "/cpd/").concat(sku, "/"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    title: "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListTitle/* default */.Z, {
                        name: name
                    })
                })
            }),
            !isDisabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    getLabels().length >= 1 && isInSpecialCampaign && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 right-0 h-auto w-auto flex flex-col items-end truncate max-w-[75%]",
                        children: getLabels().slice(0, 1).map(function(param, index) {
                            var title = param.title, variant = param.variant;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardLabel/* default */.Z, {
                                        variant: variant,
                                        className: "truncate max-w-full",
                                        children: title
                                    }, "".concat(title, "-").concat(index)),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "p-0.5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat(settings.websiteStatics, "/images/oferta-de-black-friday-listing.svg"),
                                            alt: "oferta de black friday"
                                        })
                                    })
                                ]
                            });
                        })
                    }),
                    getLabels().length >= 1 && !isInSpecialCampaign && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 right-0 h-auto w-auto flex flex-col items-end truncate max-w-[75%]",
                        children: getLabels().map(function(param, index) {
                            var title = param.title, variant = param.variant;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductCardLabel/* default */.Z, {
                                variant: variant,
                                className: "truncate max-w-full",
                                children: title
                            }, "".concat(title, "-").concat(index));
                        })
                    }),
                    getLabels().length !== 0 && isInSpecialCampaign && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 right-0 h-auto w-auto flex flex-col items-end truncate max-w-[75%] p-0.5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(settings.websiteStatics, "/images/oferta-de-black-friday-listing.svg"),
                            alt: "oferta de black friday"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-20px my-1.5 flex items-center",
                        children: hasVariationsInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListVariations/* default */.Z, {
                            variations: variations_info
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Status/* default */.Z, {
                        product: product
                    }),
                    reviews_count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-[4px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratings/* default */.Z, {
                            reviewsCount: reviews_count,
                            ratingSummary: reviews_value,
                            displayReviewsNo: true,
                            productUrl: "/".concat(url_key, "/cpd/").concat(sku, "/")
                        })
                    }),
                    hasFinancingOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-[6px] cursor-pointer w-fit",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFinancing/* default */.Z, {
                            product: product,
                            label: "productCard"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-0 mt-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                            price: price,
                            regularPrice: regular_price,
                            lowestPrice: lowest_price,
                            msrp: msrp_price,
                            formatted: true,
                            discountType: discount_type,
                            displayDiscount: true,
                            size: "smaller",
                            displayUnit: hasPricePerFactor && hasPriceUnit ? product.price_unit.split("/")[1] : false
                        })
                    }),
                    hasVariationsInfo && isSaleable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-14px sm:mt-13px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            title: "Selecteaza varianta",
                            href: "/".concat(url_key, "/cpd/").concat(sku, "/"),
                            variant: "primary",
                            display: "block",
                            isCatalog: true
                        })
                    }),
                    (isSaleable || hasStorePickup) && !hasVariationsInfo && !isWestaco && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                        product: product,
                        isCatalog: true,
                        noMargin: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute top-10px left-11px lg:top-15px lg:left-16px flex flex-col justify-center items-center space-y-1.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToWishlist/* default */.Z, {
                        product: product
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCompare/* default */.Z, {
                        product: product
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Apple_AppleFeaturedCategoryProductCard = (AppleFeaturedCategoryProductCard);

;// CONCATENATED MODULE: ./components/ShopInShop/Apple/AppleFeaturedCategoryCard.js







var AppleFeaturedCategoryCard_ref = (0,config["default"])(), AppleFeaturedCategoryCard_publicRuntimeConfig = AppleFeaturedCategoryCard_ref.publicRuntimeConfig, websiteStatics = AppleFeaturedCategoryCard_publicRuntimeConfig.settings.websiteStatics;
var AppleFeaturedCategoryCard = function(param) {
    var category = param.category, onProductClick = param.onProductClick;
    var ref1;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("ul", {
        className: "grid grid-cols-2 md:grid-cols-[35%_1fr_1fr_1fr] gap-[16px] w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("col-start-1 row-start-1 col-span-full md:col-span-1 flex flex-col items-center justify-center gap-[16px] bg-[#F5F5F7] rounded-[10px] px-[10px] py-[16px] md:min-w-[38%] lg:min-w-[30%]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithFallback/* default */.Z, {
                        src: category.image ? (0,lib_helpers/* resizeImage */.tg)(category.image, "300x300") : null,
                        fallback: "".concat(websiteStatics, "/images/applePlaceholder.svg"),
                        alt: category.name,
                        className: "w-[180px] aspect-square md:w-[300px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: category.url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            title: "Vezi toata gama ".concat(category.name),
                            className: "text-[#2A64C5] text-[18px] text-center py-[16px] px-[32px] border border-[#2A64C5] rounded-full md:text-[20px] hover:opacity-80 transition-opacity transition-duration-150",
                            children: [
                                "Vezi toata gama ",
                                category.name
                            ]
                        })
                    })
                ]
            }),
            ((ref1 = category.featured_products) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && category.featured_products.map(function(product, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                    className: classnames_default()("Products-item min-h-[330px] min-w-full h-auto bg-white", {
                        "md:col-start-2": index % 3 === 0 && index !== 0
                    }),
                    onClick: function() {
                        onProductClick(product);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Apple_AppleFeaturedCategoryProductCard, {
                        product: product,
                        onProductClick: onProductClick
                    })
                }, product.sku);
            })
        ]
    });
};
/* harmony default export */ var Apple_AppleFeaturedCategoryCard = (AppleFeaturedCategoryCard);

;// CONCATENATED MODULE: ./components/ShopInShop/Apple/AppleFeaturedCategoriesList.js



var AppleFeaturedCategoriesList = function(param) {
    var categories = param.categories, onProductClick = param.onProductClick;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("ul", {
        children: categories.map(function(category, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                className: classnames_default()({
                    "pt-[16px] mt-[16px] border-t border-[#EBEBEB]": index !== 0
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Apple_AppleFeaturedCategoryCard, {
                    index: index,
                    category: category,
                    onProductClick: onProductClick
                })
            }, category.slug);
        })
    });
};
/* harmony default export */ var Apple_AppleFeaturedCategoriesList = (AppleFeaturedCategoriesList);

// EXTERNAL MODULE: ./components/ContentEditorView/index.js + 24 modules
var ContentEditorView = __webpack_require__(51961);
;// CONCATENATED MODULE: ./pages/shop/apple/index.js
















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AppleShop = function(param) {
    var categories = param.categories, banners = param.banners, menu = param.menu, seo = param.seo, footer = param.footer, trackProductClick1 = param.trackProductClick, weekly_deal_products = param.weekly_deal_products;
    if (!categories) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
            layout: "404"
        }));
    }
    var parsedFooterObject = null;
    if (footer) {
        try {
            parsedFooterObject = JSON.parse(footer);
        } catch (error) {
            parsedFooterObject = false;
        }
    }
    var handleProductClick = function(product, options) {
        trackProductClick1(product, options);
    };
    var hasTopBanner = banners && banners.find(function(banner) {
        return banner.position === "top" && banner.type === "image";
    });
    var hasTopVideoBanner = banners && banners.find(function(banner) {
        var ref;
        return banner.position === "top" && banner.type === "video" && ((ref = banner.video) === null || ref === void 0 ? void 0 : ref.url);
    });
    var bottomBanners = banners && banners.filter(function(banner) {
        return banner.position === "bottom" && banner.type === "image";
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    (seo === null || seo === void 0 ? void 0 : seo.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: seo.title
                    }),
                    (seo === null || seo === void 0 ? void 0 : seo.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: seo.description
                    })
                ]
            }),
            menu && /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthContainer/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-[#F5F5F7]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "flex items-center text-center gap-[50px] md:gap-[60px] py-[15px] md:py-[24px] container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppleNavbar/* default */.Z, {
                            menu: menu
                        })
                    })
                })
            }),
            hasTopVideoBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthContainer/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-black",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:container md:w-[80%] lg:w-[60%] mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoBanner/* default */.Z, {
                            banner: hasTopVideoBanner
                        })
                    })
                })
            }),
            hasTopBanner && !hasTopVideoBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthContainer/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveShopBanner/* default */.Z, {
                    banner: hasTopBanner
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[40px] md:mt-[80px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Apple_AppleFeaturedCategoriesList, {
                    categories: categories,
                    onProductClick: handleProductClick
                })
            }),
            weekly_deal_products && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-[20px] md:mt-[40px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        as: "h2",
                        title: "Oferta saptamanii",
                        classesProp: "-tracking-[0.66px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableProductList/* default */.Z, {
                        products: weekly_deal_products,
                        desktopVisibleProducts: 10,
                        onProductClick: function(product) {
                            return handleProductClick(product);
                        }
                    })
                ]
            }),
            parsedFooterObject && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[40px] md:my-[50px] md:py-[50px] md:border-y md:border-[#EBEBEB]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView/* default */.Z, {
                    content: parsedFooterObject
                })
            }),
            (bottomBanners === null || bottomBanners === void 0 ? void 0 : bottomBanners.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid md:grid-cols-2 gap-[16px] md:gap-[24px]",
                children: bottomBanners.map(function(banner, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ResponsiveShopBanner/* default */.Z, {
                        banner: banner
                    }, index);
                })
            })
        ]
    }));
};
AppleShop.pageLayout = "default";
AppleShop.getInitialProps = _asyncToGenerator(runtime_default().mark(function _callee() {
    var response1, ref, ref1, ref2, ref3, ref4, updatedReponse;
    return runtime_default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return (0,helpers/* makeApiCall */.Vo)({
                    apiArgs: [
                        {
                            shopName: "apple"
                        }
                    ],
                    apiCall: api/* getShopInShopCategoriesApi */.ij6,
                    returnResponse: true,
                    formatResponse: function(response) {
                        return response.data;
                    }
                });
            case 2:
                response1 = _ctx.sent;
                if (!(response1 && response1.status)) {
                    _ctx.next = 13;
                    break;
                }
                ;
                updatedReponse = _objectSpread({}, response1);
                if (((ref = response1.menu) === null || ref === void 0 ? void 0 : ref.length) === 0) {
                    updatedReponse.menu = null;
                }
                if (((ref1 = response1.categories) === null || ref1 === void 0 ? void 0 : ref1.length) === 0) {
                    updatedReponse.categories = null;
                }
                if (((ref2 = response1.banners) === null || ref2 === void 0 ? void 0 : ref2.length) === 0) {
                    updatedReponse.banners = null;
                }
                if (((ref3 = response1.footer) === null || ref3 === void 0 ? void 0 : ref3.length) === 0) {
                    updatedReponse.footer = null;
                }
                if (response1.seo && Object.keys(response1.seo).length === 0) {
                    updatedReponse.seo = null;
                }
                if (((ref4 = response1.weekly_deal_products) === null || ref4 === void 0 ? void 0 : ref4.length) === 0) {
                    updatedReponse.weekly_deal_products = null;
                }
                return _ctx.abrupt("return", updatedReponse);
            case 13:
                return _ctx.abrupt("return", null);
            case 14:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
/* harmony default export */ var apple = ((0,es/* connect */.$j)(null, {
    trackProductClick: actions/* trackProductClick */.Cg
})(AppleShop));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1423,5866,1961,9774,2888,179], function() { return __webpack_exec__(23276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);